import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Pagination, Table } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";

import ActionCell from "../tables/actionCell";
import StatusCell from "../tables/statusCell";
import BriefCreateDrawer from "./briefCreateDrawer";

const EXPERTISE_TYPES = [
    { label: 'Экологический аудит', value: 1 },
    { label: 'ПДВ', value: 2 },
    { label: 'НМУ', value: 3 },
    { label: 'СЗЗ', value: 4 },
    { label: 'ОВЕС', value: 5 },
]

const getBriefs = (manager_id, setBriefs, setLoading) => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/?` + new URLSearchParams({
            manager_id
        }).toString(), {
            method: 'GET'
      }).then((res) => {
        res.json().then((data) => {
            setBriefs(data);
            setLoading(false);
        });
      });
    };

export default function BriefList({open, setOpen}) {
    const [briefs, setBriefs] = useState([]);

    const { Column, HeaderCell, Cell } = Table;

    const [limit, setLimit] = useState(30);
    const [page, setPage] = useState(1);
    const [tableLength, setTableLength] = useState(0);

    const [loading, setLoading] = useState(true);
    const [sortedBy, setSortedBy] = useState("name");
    const [sortedDir, setSortedDir] = useState();

    function onSortChange(sortColumn, sortType) {
        setSortedBy(sortColumn);
        setSortedDir(sortType);
    }

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };

    useEffect(() => {
        getBriefs(2, setBriefs, setLoading)
    }, []);

    return (
        <div style={{ height: "100%" }}>
            <div style={{ height: "calc(100% - 5rem)" }}>
                <Table sortColumn={sortedBy} sortType={sortedDir} loading={loading} onSortColumn={(sortColumn, sortType) => {
                    onSortChange(sortColumn, sortType)
                }} fillHeight data={briefs}>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Название</HeaderCell>
                        <Cell dataKey="name"></Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Проект</HeaderCell>
                        <Cell dataKey="expertise_type">
                            {
                            (rowData) => EXPERTISE_TYPES[rowData.expertise_type - 1].label
                            }</Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Компания</HeaderCell>
                        <Cell dataKey="org_name"></Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Статус</HeaderCell>
                        <StatusCell dataKey="status"></StatusCell>
                    </Column>
                    <Column align="center" flexGrow={1} fixed>
                        <HeaderCell></HeaderCell>
                        <ActionCell open={open} setOpen={setOpen} updateBriefs={() => getBriefs(2, setBriefs, setLoading)}></ActionCell>
                    </Column>
                </Table>
            </div>
            <div style={{ padding: 20 }}>
                <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                    total={tableLength}
                    limitOptions={[10, 30, 50]}
                    limit={limit}
                    activePage={page}
                    onChangePage={setPage}
                    onChangeLimit={handleChangeLimit}
                />
            </div>
            <BriefCreateDrawer open={open} setOpen={setOpen} updateBriefs={() => getBriefs(2, setBriefs, setLoading)}/>
        </div>
    )
}